<div class="modern-dialog-container">

    <!-- HEADER -->
    <div class="dialog-header">
        <div class="header-content">
            <div class="header-icon">
                <mat-icon>{{ isEdit ? 'edit' : icon }}</mat-icon>
            </div>
            <div class="header-text">
                <h2 class="dialog-title">
                    {{ isEdit ? ('Editar ' + title) : ('Registrar ' + title) }}
                </h2>
                <p class="dialog-subtitle">
                    {{ subtitle }}
                    <strong>{{ isEdit ? 'editar' : 'registrar' }}</strong>.
                </p>

                <!-- contenido adicional dentro del header -->
                <ng-content select="[customHeader]"></ng-content>
            </div>
        </div>
    </div>

    <!-- 🔵 CONTENIDO SUPERIOR (ej: BUSCADOR RUT) -->
    <div class="extra-top-content">
        <ng-content select="[topContent]"></ng-content>
    </div>

    <!-- CONTENIDO PRINCIPAL -->
    <div class="dialog-content" *ngIf="form">
        <form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()">

            <!-- GRID DE CAMPOS -->
            <div class="form-grid" [ngClass]="'cols-' + columns">

                <ng-container *ngFor="let field of fields">
                    <ng-container *ngIf="!field.hidden">

                        <!-- TEXT / PASSWORD / NUMBER / DATE -->
                        <mat-form-field
                            *ngIf="field.type === 'text' || field.type === 'password' || field.type === 'number' || field.type === 'date'"
                            appearance="outline" class="form-field" [class.full-width]="field.fullWidth">

                            <mat-label>{{ field.label }}</mat-label>

                            <input matInput [type]="field.type === 'text' || field.type === 'password'
                                        ? field.type
                                        : (field.type === 'number' ? 'number' : 'date')" [formControlName]="field.name"
                                [placeholder]="field.placeholder || ''" [min]="field.min" [max]="field.max"
                                [step]="field.step"
                                (input)="field.uppercase ? handleUppercase(field.name, $event) : null" />

                            <mat-hint *ngIf="field.hint">{{ field.hint }}</mat-hint>
                            <mat-error *ngIf="getErrorMessage(field.name)">
                                {{ getErrorMessage(field.name) }}
                            </mat-error>
                        </mat-form-field>

                        <!-- TEXTAREA -->
                        <mat-form-field *ngIf="field.type === 'textarea'" appearance="outline"
                            class="form-field textarea-field" [class.full-width]="true">

                            <mat-label>{{ field.label }}</mat-label>

                            <textarea matInput [rows]="field.rows || 3" [formControlName]="field.name"
                                [placeholder]="field.placeholder || ''">
                            </textarea>

                            <mat-hint *ngIf="field.hint">{{ field.hint }}</mat-hint>
                            <mat-error *ngIf="getErrorMessage(field.name)">
                                {{ getErrorMessage(field.name) }}
                            </mat-error>
                        </mat-form-field>

                        <!-- AUTOCOMPLETE -->
                        <mat-form-field *ngIf="field.type === 'autocomplete'" appearance="outline" class="form-field"
                            [class.full-width]="field.fullWidth">

                            <mat-label>{{ field.label }}</mat-label>

                            <input matInput [formControlName]="field.name" [matAutocomplete]="auto"
                                [placeholder]="field.placeholder || ''"
                                (input)="field.uppercase ? handleUppercase(field.name, $event) : null">

                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn(field.name)">
                                <mat-option *ngFor="let opt of filterOptions(field.name, form.get(field.name)?.value)" [value]="opt.value">
                                    {{ opt.label }}
                                </mat-option>
                            </mat-autocomplete>

                            <mat-hint *ngIf="field.hint">{{ field.hint }}</mat-hint>
                            <mat-error *ngIf="getErrorMessage(field.name)">
                                {{ getErrorMessage(field.name) }}
                            </mat-error>
                        </mat-form-field>

                        <!-- SELECT -->
                        <mat-form-field *ngIf="field.type === 'select'" appearance="outline" class="form-field"
                            [class.full-width]="field.fullWidth">

                            <mat-label>{{ field.label }}</mat-label>

                            <mat-select [formControlName]="field.name" [multiple]="field.multiple">

                                <mat-option *ngFor="let opt of field.options || []" [value]="opt.value">
                                    {{ opt.label }}
                                </mat-option>

                            </mat-select>

                            <mat-hint *ngIf="field.hint">{{ field.hint }}</mat-hint>
                            <mat-error *ngIf="getErrorMessage(field.name)">
                                {{ getErrorMessage(field.name) }}
                            </mat-error>
                        </mat-form-field>

                        <!-- MULTISELECT -->
                        <mat-form-field *ngIf="field.type === 'multiselect'" appearance="outline" class="form-field"
                            [class.full-width]="field.fullWidth">

                            <mat-label>{{ field.label }}</mat-label>

                            <mat-select [formControlName]="field.name" multiple>

                                <mat-option *ngFor="let opt of field.options || []" [value]="opt.value">
                                    {{ opt.label }}
                                </mat-option>

                            </mat-select>

                            <mat-hint *ngIf="field.hint">{{ field.hint }}</mat-hint>
                            <mat-error *ngIf="getErrorMessage(field.name)">
                                {{ getErrorMessage(field.name) }}
                            </mat-error>
                        </mat-form-field>

                        <!-- CHECKBOX -->
                        <div class="form-field checkbox-field" *ngIf="field.type === 'checkbox'"
                            [class.full-width]="field.fullWidth">

                            <mat-checkbox [formControlName]="field.name">
                                {{ field.label }}
                            </mat-checkbox>

                            <small class="field-hint" *ngIf="field.hint">{{ field.hint }}</small>
                        </div>

                        <!-- RADIO -->
                        <div class="form-field radio-field" *ngIf="field.type === 'radio'"
                            [class.full-width]="field.fullWidth">

                            <label class="radio-label">{{ field.label }}</label>

                            <mat-radio-group [formControlName]="field.name" class="radio-group">

                                <mat-radio-button *ngFor="let opt of field.options || []" [value]="opt.value">
                                    {{ opt.label }}
                                </mat-radio-button>

                            </mat-radio-group>

                            <small class="field-hint" *ngIf="field.hint">{{ field.hint }}</small>
                        </div>

                        <!-- FILE INPUT -->
                        <div class="form-field file-field" *ngIf="field.type === 'file'"
                            [class.full-width]="field.fullWidth">

                            <label class="file-label">{{ field.label }}</label>

                            <!-- IMAGE PREVIEW -->
                            <div class="image-preview-container" *ngIf="imagePreviews[field.name]">
                                <img [src]="imagePreviews[field.name]" class="image-preview" alt="Vista previa">
                            </div>

                            <label class="file-input-wrapper">
                                <input type="file" (change)="handleFileChange($event, field.name)" accept="image/*" />

                                <span class="file-btn">
                                    <mat-icon>upload</mat-icon>
                                    Seleccionar archivo
                                </span>

                                <span class="file-name">
                                    {{ form.get(field.name)?.value?.name
                                    || (imagePreviews[field.name] ? 'Imagen actual seleccionada' : (field.placeholder || 'Ningún archivo seleccionado')) }}
                                </span>
                            </label>

                            <small class="field-hint" *ngIf="field.hint">{{ field.hint }}</small>
                        </div>

                        <!-- MAC OS IMAGE PICKER -->
                        <div class="form-field mac-image-picker" *ngIf="field.type === 'mac-image-picker'" [class.full-width]="field.fullWidth">
                            <label class="mac-label">{{ field.label }}</label>

                            <div class="mac-picker-container">
                                <!-- AVATAR PREVIEW -->
                                <div class="mac-avatar-container">
                                    <div class="mac-avatar">
                                        <img *ngIf="imagePreviews[field.name]" [src]="imagePreviews[field.name]" alt="Preview">
                                        <mat-icon *ngIf="!imagePreviews[field.name]">person</mat-icon>
                                    </div>
                                </div>

                                <!-- SEGMENTED CONTROL -->
                                <div class="mac-segmented-control">
                                    <button type="button" 
                                            [class.active]="imagePickerMode[field.name] === 'url'" 
                                            (click)="setPickerMode(field.name, 'url')">
                                        URL
                                    </button>
                                    <button type="button" 
                                            [class.active]="imagePickerMode[field.name] === 'file'" 
                                            (click)="setPickerMode(field.name, 'file')">
                                        Subir Archivo
                                    </button>
                                </div>

                                <!-- INPUT AREA -->
                                <div class="mac-input-area">
                                    <mat-form-field appearance="outline" *ngIf="imagePickerMode[field.name] === 'url'" class="full-width">
                                        <mat-label>Enlace de la imagen</mat-label>
                                        <input matInput [formControlName]="field.name" (input)="handleMacUrlChange($event, field.name)" placeholder="https://...">
                                    </mat-form-field>

                                    <div class="mac-file-upload" *ngIf="imagePickerMode[field.name] === 'file'">
                                        <label class="mac-file-btn">
                                            <input type="file" (change)="handleMacFileChange($event, field.name)" accept="image/*" />
                                            <mat-icon>cloud_upload</mat-icon>
                                            <span>Seleccionar imagen...</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </ng-container>
                </ng-container>

            </div>

            <!-- ACCIONES -->
            <div class="dialog-actions">
                <button mat-stroked-button color="warn" type="button" (click)="onCancel()">
                    <mat-icon>close</mat-icon>
                    Cancelar
                </button>

                <button mat-flat-button color="primary" type="submit" [disabled]="form.invalid || loading">

                    <mat-icon>{{ isEdit ? 'save' : 'add' }}</mat-icon>
                    {{ isEdit ? actionTextEdit : actionTextCreate }}
                </button>
            </div>

        </form>
    </div>
</div>